import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-card text-foreground">
      <div className="border-t border-accent/20" />
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="text-xl font-bold mb-3">Nail Point Records</h3>
            <p className="text-muted-foreground text-sm mb-4 max-w-md">
              A creative house for Christian artists who take their craft and their calling seriously. Built on conviction. Refined through craft.
            </p>
            <a href="mailto:info@nailpointrecords.com" className="flex items-center gap-2 text-muted-foreground hover:text-accent transition-colors text-sm">
              <Mail className="h-4 w-4" />
              info@nailpointrecords.com
            </a>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-semibold mb-4 text-sm">Navigate</h4>
            <ul className="space-y-2">
              {[
                { to: "/artists", label: "Artists" },
                { to: "/services", label: "Services" },
                { to: "/mastering", label: "Mastering" },
                { to: "/theology", label: "Theology" },
                { to: "/blog", label: "Blog" },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-muted-foreground hover:text-accent transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Get Involved */}
          <div>
            <h4 className="font-semibold mb-4 text-sm">Get Involved</h4>
            <ul className="space-y-2">
              {[
                { to: "/apply", label: "Apply as Artist" },
                { to: "/contact", label: "Contact Us" },
                { to: "/about", label: "About" },
                { to: "/portal", label: "Artist Portal" },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-muted-foreground hover:text-accent transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-border/50">
        <div className="container mx-auto px-4 py-4 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
          <p>© {currentYear} Nail Point Records. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-accent transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-accent transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
